import {MovieTextLayer} from 'common/src/modules/movie/movieLayers.types';
import {Timestamped} from 'common/src/modules/movie/movieRendering';
import {movieBRPattern} from 'common/src/modules/movie/movie.consts';

function getTextBox(layer: MovieTextLayer | Timestamped<MovieTextLayer>): {
  x: number;
  y: number;
  w: number;
  h: number;
} {
  const source = layer.text.aeSrcTxt;
  const isBoxText = !!source.boxTxtS;

  if (isBoxText) {
    return {
      ...source.boxTxtS,
      ...source.boxTxtP,
    };
  }

  return {
    x: 0,
    y: -source.size * 0.7,
    w: layer.text.pointTextWidth,
    h:
      source.size * 0.7 +
      (source.txt.split(movieBRPattern).length - 1) * (source.lead || 1.2 * source.size),
  };
}

export default getTextBox;
